import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, css, Typography } from '@mui/material';
import { fetchArticles } from '../../backend/articles';
import { Article } from '../../../data_types';
import './ArticleDetails.css'; // Import the CSS file

const ArticleDetails: React.FC = () => {
    const { displayId } = useParams<{ displayId: string }>();
    const [article, setArticle] = useState<Article | null>(null);
    const [readTime, setReadTime] = useState<number>();

    useEffect(() => {
        const loadArticle = async () => {
            try {
                const data = await fetchArticles();
                const foundArticle = data.articles.find(article => article.displayId === (displayId ? parseInt(displayId) : NaN));
                if (foundArticle) {
                    setArticle(foundArticle);
                    setReadTime(Math.ceil(foundArticle.articleDescription.length/1000));
                } else {
                    console.error('Article not found');
                }
            } catch (error) {
                console.error('Failed to fetch article details', error);
            }
        };
    
        loadArticle();
    }, [displayId]);    

    if (!article) {
        return <Typography variant="h6" color="error">Article not found</Typography>;
    }

    return (
        <Box className="article-container">
            <Box className="article-title-container" sx={{ fontSize: { xs: '30px', sm: '36px', md: '42px', lg: '48px' } }}>
                {article.articleTitle}
            </Box>
            <Box className="article-published-date" sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px', lg: '16px' } }}>
                Published on: {new Date(article.published).toLocaleDateString()}
                <Box className="read-time">{readTime} minute read</Box>
            </Box>
            <img src={article.imageUrl === null ? `${process.env.REACT_APP_ARTICLES_DEFAULT_IMAGE_URL}` : `${process.env.REACT_APP_STATIC_FILE_ROUTE}/${article.imageUrl}`} alt={article.articleTitle} className="article-image" style={{maxHeight: article.imageUrl === null ? '560px' : '500px'}}/>
            <Box className="article-content">
                <Box className="article-content-container" 
                sx={{
                    fontSize: { xs: '16px', sm: '21px', md: '27px', lg: '32px' },
                    px: { xs: '50px', sm: '100px', md: '150px', lg: '200px' }
                }}>
                    <div dangerouslySetInnerHTML={{ __html: article.articleDescription }} />
                </Box>
            </Box>
        </Box>
    );
};

export default ArticleDetails;
